'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-tree.routes';

export class DocumentTreeComponent {
  /*@ngInject*/
  constructor(Auth, DocumentService, DTOptionsBuilder, dialogs, $stateParams, Config, $sce) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.DocumentService = DocumentService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;
    this.type = $stateParams.type || 'list';
    this.$sce = $sce;

    let documentConfig = Config.getModuleConfig(Config.Modules.Document);

    this.documentPageCategories = documentConfig.getPageCategories();
    this.navStyle = documentConfig.getNavStyle();

    this.dialogs = dialogs;

    this.pageTitle = documentConfig.getPageTitleByCategory(this.type);
    this.categories = documentConfig.getTypesByCategory(this.type);

    this.documentConfig = documentConfig;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('responsive', true)
      .withOption('order', [0, 'desc']);

    this.treeOptions = {
      nodeChildren: "children",
      dirSelectable: false,
      injectClasses: {
        ul: "a1",
        li: "a2",
        liSelected: "a7",
        iExpanded: "a3",
        iCollapsed: "a4",
        iLeaf: "a5",
        label: "a6",
        labelSelected: "a8"
      }
    };

    this.filter = "";

    this.setPreview = id => {
      this.isEmpty = id === null;

      if (!this.isEmpty) {
        this.previewUrl = this.$sce.trustAsResourceUrl("/api/storage/"+id);
      }
    };

    this.getData();
  }

  getData() {
    let _tree = angular.copy(this.documentConfig.getDocumentTree());

    let rPrepare = (node,parentId) => {
      node.nodeId = node.id;
      if (parentId) {
        node.id = parentId + "::" + node.nodeId;
      }
      
      if (!node.children) {
        node.children = [];
      } else {
        node.children.forEach(child => rPrepare(child, node.id));
      }
    };

    _tree.forEach(node => rPrepare(node));
    this._tree = _tree;
    
    this.filteredTree = [];

    let queryFn = (this.public) ? this.DocumentService.queryPublic : this.DocumentService.query;

    queryFn((data) => {
      this.data = data.filter(doc => {
        return doc.tree && doc.tree.length;
      });

      let rFindNode = (aPath, node) => {
        let search = aPath.shift();

        if (search) {

          let idx = node.findIndex(o => o.nodeId == search);

          if (idx !== -1) {

            if (aPath.length) {
              return rFindNode(aPath, node[idx].children);
            } else {
              return node[idx];
            }

          } else {
            return null;
          }

        } else {
          return null;
        }
      };

      this.data.forEach(doc => {
        //let idx = tree.findIndex(elm => elm.id == doc.type);

        doc.tree.forEach(o => {
          let node = rFindNode(o.path.split("::"), this._tree);

          if (node)
            node.children.push({
              id: o.path + "::" + doc._id,
              nodeId: doc._id,
              name: doc.title,
              description: doc.description,
              docId: doc.document,
              isLeaf: true,
              children: []
            });
        })

      });

      //this.tree = _tree.filter(node => node.children.length);

      let rMarkEmptyFolder = node => {
        if (!node.isLeaf && node.children && !node.children.length) {
          node.children = [{
            id: node.id + "::empty",
            nodeId: 'empty',
            name: '[Empty Folder]',
            docId: null,
            isLeaf: true,
            children: []
          }];
        } else if (node.children && node.children.length) {
          node.children.forEach(child => rMarkEmptyFolder(child));
        }
      };

      this._tree.forEach(node => rMarkEmptyFolder(node));
      this.tree = this._tree;

      this.filteredTree = this.tree;

    }, err => {
      console.log("Could not retrieve documents.")
    })
  }

  getCount(cat) {
    return this.data.reduce((acc, obj) => {
      return acc + (obj.type === cat);
    }, 0);
  }

  applyFilter() {

    let SEARCH = this.filter.toLowerCase();

    let TREE = angular.copy(this.tree);

    let rFn = (node, search, folderHit) => {
      let found = node.name.toLowerCase().indexOf(search) !== -1;

      node.visible = found;

      /*
      if (found)
        return true;
      */

      let subFound = !!folderHit;

      let parentFolderHit = found || folderHit;

      if (node.children.length) {
        for (let i=0; i<node.children.length; i++) {
          let ret = rFn(node.children[i], search, parentFolderHit);
          //node.children.forEach(subNode => rFn(subNode, search));
          if (ret)
            subFound = true;
        }
      }

      let retVal = found || subFound;

      if (retVal)
        node.visible = true;

      return retVal;
    };

    TREE.forEach(mainCat => rFn(mainCat, SEARCH));


    let newTree = [];
    let pFn = (node,o,root) => {

      if (node.visible) {

        //if (root) {

          o.push({
            id: node.id,
            nodeId: node.nodeId,
            name: node.name,
            description: node.description,
            docId: node.docId,
            children: []
          });

       // } else {



       // }

        node.children.forEach(child => pFn(child, o[o.length-1].children,false ));
      }

    };

    TREE.forEach(rootNode => pFn(rootNode, newTree, true));

    //console.log("++++++++");
    //console.log(newTree);

    this.filteredTree = newTree;

  }

  resetFilter() {
    this.filter = '';
    this.applyFilter();
  }

  setFilter(cat) {
    jQuery("table.dataTable").DataTable().columns(2).search(cat).draw();
  }

  getStoragePath(docId, storageId) {
    if (this.public) {
      return "/api/storage/public/"+storageId+"/ctx/"+this.getContext(docId);
    }

    return "/api/storage/"+storageId;
  }

  getContext(docId) {
    return btoa("document:"+docId);
  }

  delete(doc) {
    var that = this;

    var docText = "<br/><br/><b>" + doc.name + "</b><br/><p>" + doc.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Document?", "Do you really want to delete this document?" + docText);
    dlg.result.then(() => {
      // OK delete it
      that.DocumentService.delete({id: doc.nodeId},
        () => {
          that.getData();
          that.node = null;
        },
        err => {
          alert("Could not delete document");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.documentTree', [uiRouter])
  .config(routes)
  .component('documentTree', {
    template: require('./document-tree.html'),
    controller: DocumentTreeComponent,
    controllerAs: 'ctrl',
    bindings: {
      public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/tree/document-tree.component.js